var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bottom-bar"},[(_vm.merchantInfo.merchantStatus && _vm.merchantLogo)?_c('merchant-logo'):_c('powered-by')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }